import React from 'react';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import PropTypes from 'prop-types';

import DraggableItemWrapper, { Position } from './DraggableItemWrapper';

function always() {
    return true;
}

function SortableItem({ activeIndex, id, children, ...props }) {
    const {
        attributes,
        index,
        isDragging,
        isSorting,
        listeners,
        over,
        setNodeRef,
        transform,
        transition,
    } = useSortable({
        animateLayoutChanges: always,
        id,
    });

    const insertPosition =
        over?.id === id
            ? index > activeIndex
                ? Position.After
                : Position.Before
            : undefined;

    const style = {
        transform: isSorting ? undefined : CSS.Translate.toString(transform),
        transition,
    };

    return (
        <DraggableItemWrapper
            active={isDragging}
            dragProps={{ ...attributes, ...listeners }}
            id={id}
            insertPosition={insertPosition}
            ref={setNodeRef}
            style={style}
            {...props}
        >
            {children}
        </DraggableItemWrapper>
    );
}

SortableItem.propTypes = {
    activeIndex: PropTypes.number,
    children: PropTypes.node,
    id: PropTypes.string,
};

export default SortableItem;
